import { Type } from '@sinclair/typebox';
export const meta = Type.Record(Type.String(), Type.Union([Type.String(), Type.Number(), Type.Null()]));
export const parts = Type.Unknown();
//# sourceMappingURL=atlas.js.map